import type { MutationHookOptions } from '@apollo/client'
import {
  PeopleChartAddTeamMemberDocument,
  PeopleChartAddTeamMemberMutation,
  PeopleChartAddTeamMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  PeopleChartAddTeamMemberMutation,
  PeopleChartAddTeamMemberMutationVariables
>

export const useAddMember = (options?: Options) => {
  const [addMember, { loading }] = useMutation(PeopleChartAddTeamMemberDocument, {
    ...options,
    extractorFn: (data) => data.teamsMutations.createTeamsMembership,
  })

  return {
    loading,
    addMember,
  }
}
